import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectsDirectoryRoute: InvariantJiraRoute = {
	name: 'projects-directory',
	path: '/jira/projects',
	exact: true,
};
